import { render, staticRenderFns } from "./centreDetail.vue?vue&type=template&id=7d0108e3&"
import script from "./centreDetail.vue?vue&type=script&lang=js&"
export * from "./centreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports